import { FormContainer } from "uikit"
import React from "react"
import { Link, Redirect } from "react-router-dom"
import { Button, Grid, Input, Message, Container } from "semantic-ui-react"
import "./Overview.css"

class InviteForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      value: ""
    }
  }
  validateInviteCode(codeValue) {
    let inviteCode =
      !codeValue && codeValue !== "" ? this.state.value : codeValue
    let isValid = true
    if (!inviteCode || inviteCode === "") {
      this.setState({ error: "This field is required.", success: false })
      isValid = false
    } else if (inviteCode.length < 8) {
      this.setState({
        error: "Too short! At least 8 characters required.",
        success: false
      })
      isValid = false
    } else {
      this.setState({ error: null })
    }
    return isValid
  }
  validateAndSubmit = () => {
    if (this.validateInviteCode()) {
      this.setState({ success: true })
    }
  }
  onChange = ({ target: { value } }) => {
    this.setState({ value })
    if (this.state.error) {
      this.validateInviteCode(value)
    }
  }
  render = () => {
    let error = this.state.error
    let hasError = error ? true : false
    if (this.state.success) {
      return <Redirect to={`/signup#${this.state.value}`} />
    }
    return (
      <Container textAlign="center" className="white">
        <Grid className="overview_maindiv">
          <Grid.Row style={{ paddingBottom: "0px" }}>
            <Grid.Column textAlign="center">
              <h2 className="overview__Heading">Got an Invitation!?</h2>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered style={{ paddingTop: "0px" }}>
            <Grid.Column
              className="overview__Description"
              width={14}
              textAlign="center"
            >
              <p className="overview__DescriptionText">
                Please enter your invite code below.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns={"equal"} style={{ marginTop: "2em" }}>
            <Grid.Column width={"6"}>
              <form
                onSubmit={(e, v) => {
                  e.preventDefault()
                  this.validateAndSubmit()
                }}
              >
                <Input
                  fluid
                  data-testid="invite_code"
                  placeholder="Invite Code"
                  value={this.state.value}
                  onChange={this.onChange}
                  error={!!this.state.error}
                />
                <Message
                  error
                  hidden={!this.state.error && !this.props.customError}
                  content={this.state.error || this.props.customError}
                  style={{ textAlign: "left" }}
                />
                <p style={{ textAlign: "right", paddingTop: "0.5em" }}>
                  <Link to="/signup/plans" data-testid="plans">
                    Don't have one?
                  </Link>
                </p>
              </form>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns="equal" style={{ marginTop: "2em" }}>
            <Grid.Column textAlign="center">
              <Button
                primary
                size="big"
                className="overview_Button"
                data-testid="continue"
                onClick={(e, v) => {
                  e.preventDefault()
                  this.validateAndSubmit()
                }}
                disable={hasError.toString()}
              >
                Continue
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}

const InviteCode = FormContainer({
  invite_code: {
    type: "string",
    minLength: 8
  }
})(InviteForm)

export default InviteCode
